import React from 'react';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Form, Formik } from 'formik';
import ChipInput from 'material-ui-chip-input';
import FormDialog from './FormDialog';
import FormikTextField from './FormikTextField';
import { ProjectEditSchema, ProjectSchema } from './validation';
import ActionButton from '../buttons/ActionButton';
import SubmitButton from '../buttons/SubmitButton';
import { useCreateProject } from '../../reactQuery/projects/mutations/useCreateProject';
import { useUpdateProject } from '../../reactQuery/projects/mutations/useUpdateProject';

const initialValues = {
  name: '',
  tags: []
};

const ProjectForm = ({ open, handleClose, project, projectId }) => {
  const createProjectMutation = useCreateProject();
  const updateProjectMutation = useUpdateProject({});
  const isEditMode = Boolean(project);

  let resolvedInitalValues = {
    ...initialValues
  };

  if (isEditMode) {
    // eslint-disable-next-line camelcase
    const { name, tags, api_key, private_api_key } = project;
    resolvedInitalValues = {
      ...initialValues,
      api_key,
      name,
      private_api_key,
      tags
    };
  }

  const handleSubmit = (values, action) => {
    const options = {
      onError: handleClose,
      onSuccess: () => {
        action.resetForm();
        handleClose();
      }
    };
    if (!isEditMode) {
      createProjectMutation.mutate(values, options);
    } else {
      updateProjectMutation.mutate({ project: values, projectId }, options);
    }
  };

  return (
    <FormDialog fullWidth onClose={handleClose} open={open}>
      <DialogTitle>{isEditMode ? 'Edit' : 'Add'} Project</DialogTitle>

      <Formik
        initialValues={resolvedInitalValues}
        onSubmit={handleSubmit}
        validationSchema={isEditMode ? ProjectEditSchema : ProjectSchema}
      >
        {({ isSubmitting, values, dirty, isValid, setFieldValue }) => (
          <Form>
            <DialogContent>
              <FormikTextField autoFocus label="Project Name" name="name" required />
              {isEditMode ? (
                <>
                  <FormikTextField label="API_KEY" name="api_key" required />
                  <FormikTextField label="PRIVATE_API_KEY" name="private_api_key" required />
                  <ChipInput
                    fullWidth
                    newChipKeys={['Enter', ' ', 'Tab']}
                    onAdd={(chip) => {
                      const updatedChips = [...values.tags, chip];
                      setFieldValue('tags', updatedChips);
                    }}
                    onDelete={(chip) => {
                      const filteredChips = values.tags.filter((item) => item !== chip);
                      setFieldValue('tags', filteredChips);
                    }}
                    placeholder="Enter tags"
                    style={{ marginTop: '1rem' }}
                    value={values.tags || []}
                  />
                </>
              ) : (
                <ChipInput
                  fullWidth
                  label="Project tags"
                  newChipKeys={['Enter', ' ', 'Tab']}
                  onChange={(chips) => setFieldValue('tags', chips)}
                  style={{ marginTop: '1rem' }}
                />
              )}
            </DialogContent>
            <DialogActions>
              <ActionButton onClick={handleClose} version="secondary">
                Cancel
              </ActionButton>
              <SubmitButton
                disabled={!isValid || !dirty}
                isLoading={isSubmitting}
                version="primary"
              >
                {isEditMode ? 'Update' : 'Create'}
              </SubmitButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </FormDialog>
  );
};

export default ProjectForm;
